import React, { useCallback, useEffect, useMemo } from 'react';
import { observer } from 'mobx-react';
import { FormWrapper } from 'ksnm-common-ui/lib/Form/FormWrapper';

import { DesignLayout } from '@common/DesignLayout';
import { auditStore } from '@stores/auditStore';
import { confirmDialogStore } from '@stores/confirmDialog';
import { settingsStore } from '@stores/settingsStore';

import { Fields } from './Fields';
import { validate } from './validatorSchema';

export const Settings = observer(() => {
  const { properties, fetch, update } = settingsStore;

  useEffect(() => {
    auditStore.createAuditData({
      moduleName: 'System',
      serviceName: 'Properties',
      operationName: 'View_base_properties',
      message: `Просмотр раздела "Общие настройки"`,
    });
  }, []);

  useEffect(() => {
    fetch();
  }, [fetch]);

  const onSubmit = useCallback(
    (values) => {
      const validationResult = validate(values);
      if (validationResult) return validationResult;
      confirmDialogStore.open({
        onOk: () => {
          update(values);
        },
        text: 'Сохранить изменения?',
      });
    },
    [update],
  );

  const initialValues = useMemo(() => ({ properties }), [properties]);

  return (
    <DesignLayout>
      <FormWrapper onSubmit={onSubmit} initialValues={initialValues} layout="vertical">
        <Fields />
      </FormWrapper>
    </DesignLayout>
  );
});
